import { React, useContext, useEffect, useState } from 'react'
import {
  CFormInput,
  CImage,
  CButton,
  CModal,
  CModalBody,
  CFormText,
  CModalFooter,
  CFormSelect,
  CCol,
} from '@coreui/react'
import AddIcon from '../../../assets/addnew-icon2.svg'
import DeleteIcon from '../../../assets/deletenew-icon1.svg'

const FormFieldModal = ({ data, onSave, onCancel }) => {
  const [fieldName, setFieldName] = useState('')
  const [fieldType, setFieldType] = useState('TEXT_INPUT')
  const [isMandatory, setIsMandatory] = useState(false)
  const [optionData, setOptionData] = useState([''])
  const [dynamicErrorData, setDynamicErrorData] = useState([''])
  const [errorData, setErrorData] = useState({})

  let handleChange = (i, e) => {
    let temp = [...optionData]
    let tempErr = [...dynamicErrorData]

    tempErr[i] = ''
    temp[i] = e.target.value
    setDynamicErrorData(tempErr)
    setOptionData(temp)
  }

  let handleAdd = () => {
    setDynamicErrorData((prev) => [...prev, ''])
    setOptionData((prev) => [...prev, ''])
  }

  let handleRemove = (index) => {
    setDynamicErrorData((prev) => [...prev.filter((ele, idx) => idx !== index)])
    setOptionData((prev) => [...prev.filter((ele, idx) => idx !== index)])
  }

  const displayFields = optionData.map((ele, index) => {
    return (
      <div key={index} className="w-100 ">
        <div className="mt-2 mb-2 d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            <span style={{ fontSize: '12px' }}> {`${index + 1}.`}</span>
            <CFormInput
              size="sm"
              className="mx-3"
              value={ele}
              onChange={(e) => handleChange(index, e)}
            />
          </div>
          <div
            className={` d-flex ${
              index === optionData.length - 1 ? 'justify-content-between' : 'justify-content-end'
            }  align-items-center`}
            style={{ width: '18%' }}
          >
            {index ? (
              <img
                src={DeleteIcon}
                className="cursor-pointer "
                onClick={() => handleRemove(index)}
                style={{ width: '24px', height: '24px' }}
              />
            ) : null}
            {index === optionData.length - 1 ? (
              <img
                src={AddIcon}
                className="cursor-pointer"
                onClick={handleAdd}
                style={{ width: '24px', height: '24px' }}
              />
            ) : null}
          </div>
        </div>
        <div className="message-text error-message mx-4">
          <p>{dynamicErrorData[index]}</p>
        </div>
      </div>
    )
  })

  const validateInfo = () => {
    let temp = {}
    let tempDynamic = dynamicErrorData

    let isFormValid = true

    if (fieldName.trim().length === 0) {
      isFormValid = false
      temp.fieldName = 'Field name cannot be empty!'
    }

    if (fieldType.trim().length === 0) {
      isFormValid = false
      temp.fieldType = 'Select Field Type!'
    }

    if (fieldType === 'DROPDOWN') {
      for (let index = 0; index < optionData.length; index++) {
        const element = optionData[index]

        if (element.trim().length === 0) {
          isFormValid = false
          tempDynamic[index] = 'Option cannot be Empty!'
        }
      }
    }

    setDynamicErrorData([...tempDynamic])

    setErrorData({ ...temp })

    return isFormValid
  }

  const onSaveHandler = async () => {
    if (!validateInfo()) return
    onSave({
      name: fieldName,
      type: fieldType,
      is_mandatory: isMandatory,
      options: fieldType === 'DROPDOWN' ? optionData : [],
      value: '',
    })
  }
  return (
    <CModal
      size="lg"
      scrollable
      visible={true}
      alignment="center"
      className="custom-form-field-modal border-0"
    >
      <div
        className="px-5 text-white w-100 d-flex align-items-center"
        style={{ height: '3.8vw', backgroundImage: 'linear-gradient(to bottom, #646464, #111)' }}
      >
        <p style={{ fontSize: '1.5625vw' }} className="mb-0">
          Add New Custom Field
        </p>
      </div>
      <CModalBody
        style={{ height: '30vh' }}
        className="m-auo p-0 rounded-sm static-scrollbar-class"
      >
        <div className="px-5 w-100 mt-3">
          <div className="w-100">
            <h6 style={{ fontSize: '13px' }} className="">
              Field Name <span style={{ color: 'red' }}>*</span>
            </h6>
            <CFormInput
              type="text"
              value={fieldName}
              name="fieldName"
              size="sm"
              onChange={(e) => setFieldName(e.target.value)}
            />
            <div className="message-text error-message">
              <p>{errorData.fieldName}</p>
            </div>
          </div>
          <div className="w-100 d-flex justify-content-between mt-2">
            <div style={{ width: '58.4%' }}>
              <h6 style={{ fontSize: '13px' }} className="">
                Field Type <span style={{ color: 'red' }}>*</span>
              </h6>
              <CFormSelect
                size="sm"
                aria-label="fieldType"
                value={fieldType}
                onChange={(e) => setFieldType(e.target.value)}
              >
                <option value={'TEXT_INPUT'}>Text Input</option>
                <option value={'TEXT_AREA'}>Text Area Box</option>
                <option value={'DROPDOWN'}>Drop-down</option>
                <option value={'EMAIL'}>Email</option>
                <option value={'PHONE'}>Phone</option>
              </CFormSelect>
            </div>
            <div style={{ width: '33.6%' }}>
              <h6 style={{ fontSize: '13px' }} className="">
                Mandatory field ? <span style={{ color: 'red' }}>*</span>
              </h6>
              <CFormSelect
                size="sm"
                aria-label="isMandatory"
                value={isMandatory}
                onChange={(e) => setIsMandatory(e.target.value === 'true')}
              >
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </CFormSelect>
            </div>
          </div>
          {fieldType === 'DROPDOWN' && (
            <div style={{ width: '58.4%' }} className=" d-flex justify-content-between mt-2 ">
              <div className="w-100 ">{displayFields}</div>
            </div>
          )}
        </div>
      </CModalBody>
      <CModalFooter className="p-0 px-5 border-0">
        <div className="d-flex justify-content-end w-100  mb-4">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '.9vw' }}
            className="mr-5 bg-white rounded-1 btn-focus-none px-4"
            type="submit"
            onClick={onCancel}
          >
            Cancel
          </CButton>
          <CButton
            style={{ border: '1px solid black', fontSize: '.9vw' }}
            className="ml-2 bg-black rounded-1 btn-focus-none px-4"
            type="submit"
            onClick={onSaveHandler}
          >
            Add
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default FormFieldModal
